if (!customElements.get('museo-virtual-tour-embed')) {
  customElements.define(
    'museo-virtual-tour-embed',
    class MuseoVirtualTourEmbed extends HTMLElement {
      connectedCallback() {
        this.embed = this.querySelector('.museo-virtual-tour__embed');
        if (!this.embed) return;

        this.handleEmbedClick = this.handleEmbedClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);

        this.embed.addEventListener('click', this.handleEmbedClick);
      }

      disconnectedCallback() {
        if (this.embed) {
          this.embed.removeEventListener('click', this.handleEmbedClick);
        }
        document.removeEventListener('click', this.handleOutsideClick);
      }

      handleEmbedClick() {
        if (this.embed.classList.contains('is-active')) return;
        this.embed.classList.add('is-active');
        setTimeout(() => {
          document.addEventListener('click', this.handleOutsideClick);
        }, 0);
      }

      handleOutsideClick(e) {
        if (!this.contains(e.target)) {
          this.embed.classList.remove('is-active');
          document.removeEventListener('click', this.handleOutsideClick);
        }
      }
    }
  );
}
